import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./HeaderMenu.css";
import logo from "./Kubitos_golden_text.png"; // Ensure the correct path to the logo image
import Flag from "react-world-flags";

const HeaderMenu = () => {
  const [language, setLanguage] = useState(localStorage.getItem("language") || "pt");

  const translations = {
    en: {
      home: "Home",
      properties: "Properties",
      furniture: "Others",
      contacts: "Contacts",
      general: "General",
      opportunities: "Opportunities",
      premium: "Premium",
    },
    pt: {
      home: "Início",
      properties: "Imóveis",
      furniture: "Outros",
      contacts: "Contactos",
      general: "Geral",
      opportunities: "Oportunidades",
      premium: "Premium",
    },
    fr: {
      home: "Accueil",
      properties: "Biens",
      furniture: "Autres",
      contacts: "Contacts",
      general: "Général",
      opportunities: "Opportunités",
      premium: "Premium",
    },
  };

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem("language", lang);
    window.dispatchEvent(new Event("languageChange"));
  };

  const t = translations[language];

  return (
    <header className="header-menu">
      <div className="logo">
        <img src={logo} alt="Kubitos Logo" className="logo-image" /> {/* Ensure logo is displayed */}
      </div>
      <nav className="nav-menu">
        <ul className="menu-options">
          <li>
            <Link to="/" className="menu-item">{t.home}</Link>
          </li>
          <li>
            <Link to="/imoveis" className="menu-item">{t.properties}</Link>
          </li>
          <li>
            <Link to="/outros" className="menu-item">{t.furniture}</Link>
          </li>
          <li>
            <Link to="/contacts" className="menu-item">{t.contacts}</Link>
          </li>
        </ul>
      </nav>
      <div className="language-switcher">
        <Flag
          code="PT"
          title="Portuguese"
          className={`language-flag ${language === "pt" ? "active" : ""}`}
          onClick={() => handleLanguageChange("pt")}
        />
        <Flag
          code="GB"
          title="English"
          className={`language-flag ${language === "en" ? "active" : ""}`}
          onClick={() => handleLanguageChange("en")}
        />
        <Flag
          code="FR"
          title="French"
          className={`language-flag ${language === "fr" ? "active" : ""}`}
          onClick={() => handleLanguageChange("fr")}
        />
      </div>
    </header>
  );
};

export default HeaderMenu;
// No API URLs in this file, so no changes needed.
